export const CONSTANT = {
    COMBOBOX: {
      CATEGORY: "Category",
    }
}